import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Constants} from '../../common/constants';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Report} from '../../model/report';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {Set} from "../../model/set";

@Injectable()
export class SetService {

  static readonly SET_SERVICE_URL = environment.apiUrl.concat(environment.setServiceUrl);
  static readonly CREATE_SET_SERVICE_URL = environment.apiUrl.concat(environment.createSetServiceUrl);
  static readonly DELETE_SET_SERVICE_URL = environment.apiUrl.concat(environment.deleteSetServiceUrl);
  static readonly UPDATE_SET_SERVICE_URL = environment.apiUrl.concat(environment.updateSetServiceUrl);
  static readonly GET_SET_SERVICE_URL = environment.apiUrl.concat(environment.getSetServiceUrl);
  static readonly LIST_REPORTS_SERVICE_URL = environment.apiUrl.concat(environment.reportListServiceUrl);

  constructor(private httpClient: MasbitHttpService) { };

  getSetList(sortString : string): Observable<any> {
    return this.httpClient.post(SetService.SET_SERVICE_URL, {'sortString' : sortString});
  };

  getReportsBySetIds(setIds: Array<number>) : Observable<BackendServiceResponse<string, Array<Report>>> {
    return this.httpClient.post<BackendServiceResponse<string, Array<Report>>>(SetService.LIST_REPORTS_SERVICE_URL, {sets: setIds});
  }

  getFilteredSetList(setData : any) : Observable<any> {
    return this.httpClient.post(SetService.SET_SERVICE_URL, setData);
  }

  getDictContentType(): Observable<any> {
    return this.httpClient.post(Constants.DICT_CONTENT_TYPE_URL);
  };

  getDictProduct() : Observable<any> {
    return this.httpClient.post(Constants.DICT_PRODUCTS_URL);
  };

  getDictInstitution() : Observable<any> {
    return this.httpClient.post(Constants.DICT_INSTITUTION_URL);
  };

  getClientGroups() : Observable<any> {
    return this.httpClient.post(Constants.DICT_CLIENT_GROUPS_URL);
  }

  getInterestArea() : Observable<any> {
    return this.httpClient.post(Constants.DICT_INTEREST_AREA_URL);
  }

  getPublicationFreqency() : Observable<any> {
    return this.httpClient.post(Constants.DICT_PUBLICATION_FREQUENCY_URL);
  }

  createSet(setData: any) : Observable<any> {
    return this.httpClient.put(SetService.CREATE_SET_SERVICE_URL, setData);
  }

  updateSet(setData: any) : Observable<any> {
    return this.httpClient.post(SetService.UPDATE_SET_SERVICE_URL, setData);
  }

  deleteSets(setsToRemove: Array<number>) : Observable<any> {
    return this.httpClient.delete(SetService.DELETE_SET_SERVICE_URL, new HttpParams().set('setIds', JSON.stringify(setsToRemove)));
  }

  getSet(id : string) : Observable<any> {
    return this.httpClient.post(SetService.GET_SET_SERVICE_URL, {id : id});
  }
}
